import React from 'react';
import '../../css/dataEntry.css';

const InfoPanel = ({ title, description }) => {
    const formatText = (children) => {
        return children.map((child, index) => {
            const style = {
                fontWeight: child.bold ? 'bold' : 'normal',
                fontStyle: child.italic ? 'italic' : 'normal',
                textDecoration: (child.underline ? 'underline ' : '') + (child.strikethrough ? 'line-through' : ''),
                color: child.color ? child.color : 'inherit',
                fontSize: child.size ? `${child.size}px` : 'inherit',
                textDecorationLine: child.underline ? 'underline' : (child.strikethrough ? 'line-through' : 'none'),
                textDecorationStyle: child.underline ? 'solid' : 'none',
            };

            if (child.link) {
                return (
                    <a key={index} href={child.link} style={style} target="_blank" rel="noopener noreferrer">
                        {child.text}
                    </a>
                );
            } else {
                return (
                    <span key={index} style={style}>
                        {child.text}
                    </span>
                );
            }
        });
    };

    const renderContent = (item) => {
        switch (item.type) {
            case 'paragraph':
                return <p>{formatText(item.children)}</p>;
            case 'heading':
                const Tag = `h${item.level}`; // Dynamic HTML heading tag
                return <Tag>{formatText(item.children)}</Tag>;
            case 'image':
                return (
                    <img
                        src={item.image.url}
                        alt={item.image.alternativeText || 'Image'}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '500px',
                            width: 'auto',
                            height: 'auto',
                            display: 'block',
                            margin: '0 auto'
                        }}
                    />
                );
            case 'list':
                return (
                    <ul style={{ margin: '0', paddingLeft: '20px' }}>
                        {item.children.map((listItem, index) => (
                            <li key={index}>
                                {formatText(listItem.children)}
                            </li>
                        ))}
                    </ul>
                );
            case 'list-item':
                return <li>{formatText(item.children)}</li>;
            default:
                return null;
        }
    };

    return (
        <div className="details-container">
            {title && <h3 style={{ textAlign: 'center' }}>{title}</h3>}
            {description?.map((item, index) => (
                <div key={index}>
                    {renderContent(item)}
                </div>
            ))}
        </div>
    );
};

export default InfoPanel;
